import styled from 'styled-components';
import { StyledCartProductMiniatureProps } from './CartProductMiniature.types';

export const StyledCartProductMiniature = styled.article<StyledCartProductMiniatureProps>`
  .cart-product-miniature__delete-from-cart {
    cursor: pointer;
  }

  ${(props) => props.customStyle}
`;
